"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecentralandEstates = void 0;
exports.DecentralandEstates = [
    {
        constant: true,
        inputs: [{ name: "_interfaceId", type: "bytes4" }],
        name: "supportsInterface",
        outputs: [{ name: "", type: "bool" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [{ name: "", type: "string" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            { name: "_name", type: "string" },
            { name: "_symbol", type: "string" },
            { name: "_registry", type: "address" },
        ],
        name: "initialize",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [{ name: "_tokenId", type: "uint256" }],
        name: "getApproved",
        outputs: [{ name: "", type: "address" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            { name: "_to", type: "address" },
            { name: "_tokenId", type: "uint256" },
        ],
        name: "approve",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [{ name: "", type: "uint256" }],
        name: "landIdEstate",
        outputs: [{ name: "", type: "uint256" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            { name: "_operator", type: "address" },
            { name: "_from", type: "address" },
            { name: "_tokenId", type: "uint256" },
            { name: "_data", type: "bytes" },
        ],
        name: "onERC721Received",
        outputs: [{ name: "", type: "bytes4" }],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [{ name: "estateId", type: "uint256" }],
        name: "getFingerprint",
        outputs: [{ name: "result", type: "bytes32" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [{ name: "", type: "uint256" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            { name: "_from", type: "address" },
            { name: "_to", type: "address" },
            { name: "_tokenId", type: "uint256" },
        ],
        name: "transferFrom",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            { name: "estateId", type: "uint256" },
            { name: "landId", type: "uint256" },
            { name: "data", type: "string" },
        ],
        name: "updateLandData",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            { name: "_owner", type: "address" },
            { name: "_index", type: "uint256" },
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [{ name: "", type: "uint256" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            { name: "", type: "uint256" },
            { name: "", type: "uint256" },
        ],
        name: "estateLandIds",
        outputs: [{ name: "", type: "uint256" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            { name: "estateId", type: "uint256" },
            { name: "landIds", type: "uint256[]" },
            { name: "destinatary", type: "address" },
        ],
        name: "transferManyLands",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            { name: "estateId", type: "uint256" },
            { name: "landIds", type: "uint256[]" },
            { name: "data", type: "string" },
        ],
        name: "updateManyLandData",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            { name: "_from", type: "address" },
            { name: "_to", type: "address" },
            { name: "_tokenId", type: "uint256" },
        ],
        name: "safeTransferFrom",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            { name: "_name", type: "string" },
            { name: "_symbol", type: "string" },
        ],
        name: "initialize",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [{ name: "_tokenId", type: "uint256" }],
        name: "exists",
        outputs: [{ name: "", type: "bool" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [{ name: "_index", type: "uint256" }],
        name: "tokenByIndex",
        outputs: [{ name: "", type: "uint256" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [{ name: "_registry", type: "address" }],
        name: "setLANDRegistry",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            { name: "estateId", type: "uint256" },
            { name: "metadata", type: "string" },
        ],
        name: "updateMetadata",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "ping",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [{ name: "_tokenId", type: "uint256" }],
        name: "ownerOf",
        outputs: [{ name: "", type: "address" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            { name: "operator", type: "address" },
            { name: "estateId", type: "uint256" },
        ],
        name: "isUpdateAuthorized",
        outputs: [{ name: "", type: "bool" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [{ name: "_owner", type: "address" }],
        name: "balanceOf",
        outputs: [{ name: "", type: "uint256" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            { name: "from", type: "address" },
            { name: "to", type: "address" },
            { name: "estateIds", type: "uint256[]" },
        ],
        name: "safeTransferManyFrom",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "registry",
        outputs: [{ name: "", type: "address" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "initialize",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [{ name: "", type: "address" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            { name: "estateId", type: "uint256" },
            { name: "fingerprint", type: "bytes" },
        ],
        name: "verifyFingerprint",
        outputs: [{ name: "", type: "bool" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [{ name: "", type: "string" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [{ name: "", type: "uint256" }],
        name: "updateOperator",
        outputs: [{ name: "", type: "address" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            { name: "", type: "uint256" },
            { name: "", type: "uint256" },
        ],
        name: "estateLandIndex",
        outputs: [{ name: "", type: "uint256" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            { name: "_to", type: "address" },
            { name: "_approved", type: "bool" },
        ],
        name: "setApprovalForAll",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            { name: "estateId", type: "uint256" },
            { name: "landId", type: "uint256" },
            { name: "destinatary", type: "address" },
        ],
        name: "transferLand",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [{ name: "estateId", type: "uint256" }],
        name: "getMetadata",
        outputs: [{ name: "", type: "string" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            { name: "estateId", type: "uint256" },
            { name: "operator", type: "address" },
        ],
        name: "setUpdateOperator",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            { name: "_from", type: "address" },
            { name: "_to", type: "address" },
            { name: "_tokenId", type: "uint256" },
            { name: "_data", type: "bytes" },
        ],
        name: "safeTransferFrom",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [{ name: "landId", type: "uint256" }],
        name: "getLandEstateId",
        outputs: [{ name: "", type: "uint256" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            { name: "contractName", type: "string" },
            { name: "migrationId", type: "string" },
        ],
        name: "isMigrated",
        outputs: [{ name: "", type: "bool" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [{ name: "_sender", type: "address" }],
        name: "initialize",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [{ name: "_tokenId", type: "uint256" }],
        name: "tokenURI",
        outputs: [{ name: "", type: "string" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            { name: "to", type: "address" },
            { name: "metadata", type: "string" },
        ],
        name: "mint",
        outputs: [{ name: "", type: "uint256" }],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            { name: "from", type: "address" },
            { name: "to", type: "address" },
            { name: "estateIds", type: "uint256[]" },
            { name: "data", type: "bytes" },
        ],
        name: "safeTransferManyFrom",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            { name: "_owner", type: "address" },
            { name: "_operator", type: "address" },
        ],
        name: "isApprovedForAll",
        outputs: [{ name: "", type: "bool" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [{ name: "newOwner", type: "address" }],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [{ name: "estateId", type: "uint256" }],
        name: "getEstateSize",
        outputs: [{ name: "", type: "uint256" }],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, name: "previousOwner", type: "address" },
            { indexed: true, name: "newOwner", type: "address" },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, name: "_from", type: "address" },
            { indexed: true, name: "_to", type: "address" },
            { indexed: true, name: "_tokenId", type: "uint256" },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, name: "_owner", type: "address" },
            { indexed: true, name: "_approved", type: "address" },
            { indexed: true, name: "_tokenId", type: "uint256" },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, name: "_owner", type: "address" },
            { indexed: true, name: "_operator", type: "address" },
            { indexed: false, name: "_approved", type: "bool" },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, name: "_owner", type: "address" },
            { indexed: true, name: "_estateId", type: "uint256" },
            { indexed: false, name: "_data", type: "string" },
        ],
        name: "CreateEstate",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, name: "_estateId", type: "uint256" },
            { indexed: true, name: "_landId", type: "uint256" },
        ],
        name: "AddLand",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, name: "_estateId", type: "uint256" },
            { indexed: true, name: "_landId", type: "uint256" },
            { indexed: true, name: "_destinatary", type: "address" },
        ],
        name: "RemoveLand",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, name: "_assetId", type: "uint256" },
            { indexed: true, name: "_holder", type: "address" },
            { indexed: true, name: "_operator", type: "address" },
            { indexed: false, name: "_data", type: "string" },
        ],
        name: "Update",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, name: "_estateId", type: "uint256" },
            { indexed: true, name: "_operator", type: "address" },
        ],
        name: "UpdateOperator",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [{ indexed: true, name: "_registry", type: "address" }],
        name: "SetLANDRegistry",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: false, name: "contractName", type: "string" },
            { indexed: false, name: "migrationId", type: "string" },
        ],
        name: "Migrated",
        type: "event",
    },
];
//# sourceMappingURL=DecentralandEstates.js.map